import React from 'react';
import { dashboardKPIs, geoMix } from '../../mock';

export default function Dashboard() {
  return (
    <section className="py-20 lg:py-32 bg-[#0F1C40] text-[#F1EDE4]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-10 lg:mb-14 items-end">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-neutral-500 mb-4">
              <span className="w-2 h-2 rounded-full bg-emerald-500 pulse-dot" />
              <span>Live Dashboard · Q2 2026</span>
            </div>
            <h2 className="text-4xl lg:text-6xl tracking-tight leading-[1.02] font-medium">
              LeadAudit AI <span className="font-serif italic font-normal text-neutral-500">— snapshot.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-neutral-800 mb-8">
          {dashboardKPIs.map((k, i) => (
            <div key={k.label} className="bg-[#0F1C40] p-6 lg:p-8">
              <div className="text-[10px] font-mono uppercase tracking-widest text-neutral-500 mb-3">{k.label}</div>
              <div className="text-4xl lg:text-5xl font-medium tabular tracking-tight">{k.value}</div>
              <div className="text-xs text-neutral-400 mt-2">{k.sub}</div>
              {i === 1 && (
                <div className="mt-4 h-1 bg-neutral-800 rounded-full overflow-hidden">
                  <div className="h-full bg-[#4ECDC4]" style={{ width: '78.4%' }} />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-2 gap-6">
          <div className="bg-neutral-900 rounded-2xl p-8 reveal">
            <div className="text-[10px] font-mono uppercase tracking-widest text-neutral-500 mb-6">Global lead distribution</div>
            <div className="space-y-5">
              {geoMix.map((g) => (
                <div key={g.region}>
                  <div className="flex items-baseline justify-between mb-1.5">
                    <span className="text-sm font-medium">{g.region}</span>
                    <span className="font-mono text-xs text-neutral-500">{g.leads} leads</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="flex-1 h-2 bg-neutral-800 rounded-full overflow-hidden">
                      <div className="h-full bg-[#4ECDC4]" style={{ width: `${g.pct}%` }} />
                    </div>
                    <span className="font-mono text-xs w-10 text-right">{g.pct}%</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-neutral-900 rounded-2xl p-8 reveal">
            <div className="text-[10px] font-mono uppercase tracking-widest text-neutral-500 mb-6">Suppression breakdown · blocked at intake</div>
            <div className="flex items-center justify-center py-6">
              <div className="relative w-48 h-48">
                <svg viewBox="0 0 100 100" className="w-full h-full -rotate-90">
                  <circle cx="50" cy="50" r="40" fill="none" stroke="#262626" strokeWidth="14" />
                  <circle cx="50" cy="50" r="40" fill="none" stroke="#4ECDC4" strokeWidth="14" strokeDasharray="115.5 251" strokeDashoffset="0" />
                  <circle cx="50" cy="50" r="40" fill="none" stroke="#7DDBD1" strokeWidth="14" strokeDasharray="80.3 251" strokeDashoffset="-115.5" />
                  <circle cx="50" cy="50" r="40" fill="none" stroke="#B8E8E2" strokeWidth="14" strokeDasharray="55.2 251" strokeDashoffset="-195.8" />
                </svg>
                <div className="absolute inset-0 flex flex-col items-center justify-center">
                  <div className="text-3xl font-medium tabular">16,817</div>
                  <div className="text-[10px] font-mono uppercase tracking-widest text-neutral-500">Total blocked</div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-3 text-center">
              <div><div className="w-3 h-3 bg-[#4ECDC4] rounded-full mx-auto mb-2" /><div className="font-mono text-sm">7,736</div><div className="text-[10px] text-neutral-500">Campaign 46%</div></div>
              <div><div className="w-3 h-3 bg-[#7DDBD1] rounded-full mx-auto mb-2" /><div className="font-mono text-sm">5,381</div><div className="text-[10px] text-neutral-500">Agency 32%</div></div>
              <div><div className="w-3 h-3 bg-[#B8E8E2] rounded-full mx-auto mb-2" /><div className="font-mono text-sm">3,700</div><div className="text-[10px] text-neutral-500">Client 22%</div></div>
            </div>
          </div>
        </div>

        <div className="mt-8 flex items-center justify-between text-[10px] font-mono uppercase tracking-widest text-neutral-500">
          <span>21.6% Failed / Suppressed</span>
          <span>78.4% Passed & Delivered</span>
        </div>
      </div>
    </section>
  );
}
